import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const ProductsReload = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate("/products");
  }, [])

  return (
    <></>
  );
};
